/**
 * Ryan O'Dowd
 * 2023-09-09
 * © Copyright 2023 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, colors}) => {
  return {
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: globalScale * 4,
    },
    innerContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderWidth: globalScale * 3,
      borderRadius: globalScale * 6,
      borderColor: colors.lightGray,
      width: globalScale * 26,
      aspectRatio: 1,
    },
    activeInnerContainer: {
      backgroundColor: colors.accent,
    },
    reviewInnerContainer: {
      backgroundColor: colors.complete,
    },
    indeterminateInnerContainer: {
      backgroundColor: colors.primaryLight,
    },
    inactiveInnerContainer: {
      backgroundColor: 'transparent',
    },
    disabledInnerContainer: {
      backgroundColor: colors.gray,
      opacity: 0.5,
    },
    letterText: {
      fontSize: globalScale * 14,
      fontFamily: fonts.secondaryBold,
      color: colors.primaryDark,
    },
    disabledLetterText: {
      color: colors.lightGray,
    },
    legendText: {
      fontSize: globalScale * 12,
      color: colors.white,
    },
  };
};

export default getStyles;
